var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOntarioLogoDesktop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ontario-logo--desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 45.2,
    viewBox: "0 0 180 45.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M0,25.5C0,18,4.6,13.3,12.5,13.3S25,18,25,25.5,20.4,37.7,12.5,37.7C4.5,37.7,0,32.9,0,25.5Zm12.5,8a7.526,7.526,0,0,0,5.6-2.2,8.644,8.644,0,0,0,2.1-5.9,8.19,8.19,0,0,0-2.1-5.9,7.387,7.387,0,0,0-5.7-2.2,7.526,7.526,0,0,0-5.6,2.2,8.644,8.644,0,0,0-2.1,5.9,8.029,8.029,0,0,0,2.1,5.9A7.387,7.387,0,0,0,12.5,33.5Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M41.2,37.2V26.8c0-2.7-1.4-4.3-3.8-4.3s-3.8,1.7-3.8,4.3V37.3H29.1v-18h4.5v2.6A7.357,7.357,0,0,1,39.5,19c3.8,0,6.1,2.6,6.1,6.7V37.4l-4.4-.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M60.1,36.6a7.3,7.3,0,0,1-3.8.9c-3.1,0-5.2-1.3-5.2-5.4V22.7H48.9V19.2h2.2V14.6h4.5v4.6H60v3.5H55.6v8.5a2.092,2.092,0,0,0,2.3,2.4,5.214,5.214,0,0,0,2.3-.5v3.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M64.4,20.3A15.965,15.965,0,0,1,71.1,19c5.6,0,8,2.9,8,7.8V37.3H74.9V35.6a9.434,9.434,0,0,1-6.1,2c-3.3,0-6-1.9-6-5.4v-.1c0-4.1,3-5.9,7.1-5.9a18.461,18.461,0,0,1,5.1.7v-.4c0-2.6-1.7-4-4.7-4a14.412,14.412,0,0,0-5.1,1Zm6,14.3c2.6,0,4.5-1.5,4.5-3.7V29.6l-.4-.2a8.97,8.97,0,0,0-3.4-.6c-2.5,0-4,1.2-4,3V32C67.1,33.6,68.4,34.6,70.4,34.6Z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M83.6,37.2v-18H88v3.6c1.2-2.5,2.7-4.1,6-4v3.9h-.1a5.9,5.9,0,0,0-4,1.4,7.342,7.342,0,0,0-2,5.6v7.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M102.4,16.5V12.6H97.7v3.9Zm-4.6,2.7h4.5v18H97.8Z",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M106.3,28.3c0-5.8,3.7-9.4,9.8-9.4s9.7,3.6,9.8,9.4c0,5.8-3.7,9.4-9.8,9.4C109.9,37.7,106.3,34,106.3,28.3Zm9.8,5.6a5.123,5.123,0,0,0,3.9-1.5,6.075,6.075,0,0,0,1.4-4.2A6.255,6.255,0,0,0,120,24a5.349,5.349,0,0,0-3.9-1.6,5.123,5.123,0,0,0-3.9,1.5,6.075,6.075,0,0,0-1.4,4.2,6.255,6.255,0,0,0,1.4,4.2A4.717,4.717,0,0,0,116.1,33.9Z",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M157.5,0C142.2,0,135,7.2,135,22.6c0,15.3,7.2,22.6,22.5,22.6S180,37.9,180,22.6C180,7.2,172.8,0,157.5,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M157.5,12.9a15.443,15.443,0,0,1,15.4-1.1l.2.1v.2a16.9,16.9,0,0,1-2,6.6,15.581,15.581,0,0,1-5.7,5.7h0c-.1.1-.2.1-.4.2l-.6.3a15.247,15.247,0,0,1-6.7,13.9l-.2.1-.1-.1a15.287,15.287,0,0,1-4.7-5.1,15.479,15.479,0,0,1-2.1-7.8h0a3.4,3.4,0,0,1,.1-1,15.33,15.33,0,0,1-8.6-12.8v-.2l.2-.1a15.711,15.711,0,0,1,6.7-1.6,14.857,14.857,0,0,1,7.7,2.1h0A2.407,2.407,0,0,0,157.5,12.9Zm5.8,8.4a12.329,12.329,0,0,0,4.3-4.2,19.553,19.553,0,0,0,1.2-2.6,11.19,11.19,0,0,0-8.2,1.2,2.812,2.812,0,0,1,.5,1.1,2.516,2.516,0,0,1,.1,1.5c-.1.2-.1.4-.2.6a4.806,4.806,0,0,1-2.9,1.9,3.572,3.572,0,0,0-1.3-3.8,10.382,10.382,0,0,0-1.7-1.2,11.472,11.472,0,0,0-5.8-1.6,9.246,9.246,0,0,0-2.9.4,11.971,11.971,0,0,0,5.1,6.6,6.07,6.07,0,0,1,.7-1,2.326,2.326,0,0,1,1.2-.8,1.268,1.268,0,0,1,.6-.1,5,5,0,0,1,3.1,1.5,3.493,3.493,0,0,0-2.6,3,15.028,15.028,0,0,0-.2,2,11.94,11.94,0,0,0,1.5,5.8,8.362,8.362,0,0,0,1.8,2.3,11.78,11.78,0,0,0,3.1-7.8,2.553,2.553,0,0,1-1.2-.1,4.15,4.15,0,0,1-1.3-.7c-.1-.2-.3-.3-.4-.5a4.831,4.831,0,0,1-.2-3.4,3.621,3.621,0,0,0,3.9.8A15.108,15.108,0,0,0,163.3,21.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOntarioLogoDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ontario-logo-desktop.45854b4053e148d82062ba86ea44aedb.svg";